/* eslint-disable no-useless-escape */
import reduce from 'lodash/reduce';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import * as moment from 'moment';
import 'moment-timezone';
import store from '../store/store';
import { IStateType } from '../store/models/root.interface';
import { includes } from 'lodash';
import {
	TITLE_VALIDATION_REGEX,
	SIP_PATTERN,
	subaccountCustomerTypeId,
	subaccountFlag,
	enable_failover_companies,
	internal_domains,
	resellerSubaccountCustomerTypeId,
	supportRoleId,
	nonPrimaryRoleId,
	numberRoleId,
	enterpriseSubaccountCustomerTypeId,
	parentCustomerTypeId,
	resellerCustomerTypeId,
	CNP_1846_Company,
	operationRoleId,
	ownerRoleId,
	whatsappOnlyRoleId,
	enterpriseCustomerTypeId,
	whiteListedEmailKeywords,
	userPodEu,
	userPodUS,
	viewOnlyRoleId,
	kaleyraExpertRoles,
	comManagerRoleId
} from '../constants';
import {
	HIDE_FEATURES,
	REACT_APP_ENABLE_SUBACCOUNTS_WITH_VOICE,
	REACT_APP_ENABLE_SUBACCOUNTS_WITH_WA,
	WHITELISTED_API_KEY_LIMIT,
	WHATSAPP_EMBEDED_SIGNUP_REGIONS,
	REACT_APP_DISABLE_RECEIVE_MESSAGE,
	REACT_APP_DISABLE_VOICE_EMAIL_CHANNEL_VERIFY
} from '../base';
import { redirectToLogin } from '../store/login';
import { SidebarMenuProps } from '../components/common/KDSLeftSideBar/KDSLeftSideBar';
import { kaleyraExpertDefaultRoleId , kaleyraExpertExtendedRoleId } from '../constants';

export const convertObjToArray = (obj: Record<string, any>) => {
	return Object.keys(obj).map((key) => ({
		smsStatus: key,
		percentage: obj[key],
	}));
};

export const calculatePercentage = (
	partialValue: number,
	totalValue: number
) => {
	return Math.round((100 * partialValue) / totalValue);
};

export const normalizeData = (arr: Record<string, any>, key: string) => {
	return reduce(
		arr,
		function (accumulator: any, current: any) {
			accumulator[current[key]] = current;
			return accumulator;
		},
		{}
	);
};

export const capitalizeFirstLetter = (str: string) => {
	return startCase(camelCase(str));
};

export const removeEmojisTextfield = (str: string) => {
	return !/[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu.test(
		str
	);
};

export const detectUrlInString = (str: string) => {
	if (
		new RegExp(
			'([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?'
		).test(str)
	) {
		return true;
	} else {
		return false;
	}
};

export const getLanguageFullForm = (lng: string) => {
	let language = '';
	switch (lng) {
		case 'af':
			language = 'Afrikaans';
			break;
		case 'sq':
			language = 'Albanian';
			break;
		case 'ar':
			language = 'Arabic';
			break;
		case 'az':
			language = 'Azerbaijani';
			break;
		case 'bn':
			language = 'Bengali';
			break;
		case 'bg':
			language = 'Bulgarian';
			break;
		case 'ca':
			language = 'Catalan';
			break;
		case 'zh_CN':
			language = 'Chinese (CHN)';
			break;
		case 'zh_HK':
			language = 'Chinese (HKG)';
			break;
		case 'zh_TW':
			language = 'Chinese (TAI)';
			break;
		case 'hr':
			language = 'Croatian';
			break;
		case 'cs':
			language = 'Czech';
			break;
		case 'da':
			language = 'Danish';
			break;
		case 'nl':
			language = 'Dutch';
			break;
		case 'en':
			language = 'English';
			break;
		case 'en_GB':
			language = 'English (UK)';
			break;
		case 'en_US':
			language = 'English (US)';
			break;
		case 'et':
			language = 'Estonian';
			break;
		case 'fil':
			language = 'Filipino';
			break;
		case 'fi':
			language = 'Finnish';
			break;
		case 'fr':
			language = 'French';
			break;
		case 'de':
			language = 'German';
			break;
		case 'el':
			language = 'Greek';
			break;
		case 'gu':
			language = 'Gujarati';
			break;
		case 'ha':
			language = 'Hausa';
			break;
		case 'he':
			language = 'Hebrew';
			break;
		case 'hi':
			language = 'Hindi';
			break;
		case 'hu':
			language = 'Hungarian';
			break;
		case 'id':
			language = 'Indonesian';
			break;
		case 'ga':
			language = 'Irish';
			break;
		case 'it':
			language = 'Italian';
			break;
		case 'ja':
			language = 'Japanese';
			break;
		case 'kn':
			language = 'Kannada';
			break;
		case 'kk':
			language = 'Kazakh';
			break;
		case 'ko':
			language = 'Korean';
			break;
		case 'lo':
			language = 'Lao';
			break;
		case 'lv':
			language = 'Latvian';
			break;
		case 'lt':
			language = 'Lithuanian';
			break;
		case 'mk':
			language = 'Macedonian';
			break;
		case 'ms':
			language = 'Malay';
			break;
		case 'ml':
			language = 'Malayalam';
			break;
		case 'mr':
			language = 'Marathi';
			break;
		case 'nb':
			language = 'Norwegian';
			break;
		case 'fa':
			language = 'Persian';
			break;
		case 'pl':
			language = 'Polish';
			break;
		case 'pt_BR':
			language = 'Portuguese (BR)';
			break;
		case 'pt_PT':
			language = 'Portuguese (POR)';
			break;
		case 'pa':
			language = 'Punjabi';
			break;
		case 'ro':
			language = 'Romanian';
			break;
		case 'ru':
			language = 'Russian';
			break;
		case 'sr':
			language = 'Serbian';
			break;
		case 'sk':
			language = 'Slovak';
			break;
		case 'sl':
			language = 'Slovenian';
			break;
		case 'es':
			language = 'Spanish';
			break;
		case 'es_AR':
			language = 'Spanish (ARG)';
			break;
		case 'es_ES':
			language = 'Spanish (SPA)';
			break;
		case 'es_MX':
			language = 'Spanish (MEX)';
			break;
		case 'sw':
			language = 'Swahili';
			break;
		case 'sv':
			language = 'Swedish';
			break;
		case 'ta':
			language = 'Tamil';
			break;
		case 'te':
			language = 'Telugu';
			break;
		case 'th':
			language = 'Thai';
			break;
		case 'tr':
			language = 'Turkish';
			break;
		case 'uk':
			language = 'Ukrainian';
			break;
		case 'ur':
			language = 'Urdu';
			break;
		case 'uz':
			language = 'Uzbek';
			break;
		case 'vi':
			language = 'Vietnamese';
			break;
		case 'zu':
			language = 'Zulu';
			break;
		case 'BR':
			language = 'Portuguese';
			break;
		case 'pt_BR':
			language = 'Portuguese';
			break;
	}

	return language;
};

export const formatNumber = (n: number): string => {
	if (n < 1e3) return n.toString();
	if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'k';
	if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'm';
	if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'b';
	if (n >= 1e12) return +(n / 1e12).toFixed(1) + 't';
	return '0';
};

export const elementInViewport = (el: any) => {
	var top = el.offsetTop;
	var left = el.offsetLeft;
	var width = el.offsetWidth;
	var height = el.offsetHeight;

	while (el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	}

	return (
		top >= window.pageYOffset &&
		left >= window.pageXOffset &&
		top + height <= window.pageYOffset + window.innerHeight &&
		left + width <= window.pageXOffset + window.innerWidth
	);
};

export const date12HrFormat = (
	date: string,
	seconds: boolean = false,
	timeZone: string = '',
	formatMonthFirst: boolean = false,
	withoutTime = false,
	capitaliseTimeFormat = false,
	onlyTimeWithMilliseconds = false,
	InputdateInCustomFormat?: string
) => {
	let format = '';
	if (formatMonthFirst) {
		format = 'MMM DD, YYYY hh:mm a';
	} else {
		format = 'DD MMM YYYY, hh:mm a';
	}
	if (seconds) {
		format = `DD MMM YYYY, hh:mm:ss ${capitaliseTimeFormat ? 'A' : 'a'}`;
	}
	if (withoutTime) {
		format = 'DD MMM YYYY';
	}
	if (timeZone && timeZone.length) {
		return moment.default(date, InputdateInCustomFormat).tz(timeZone).format(format);
	}
	if (onlyTimeWithMilliseconds) {
		return moment
			.default(date, 'HH:mm:ss.SSS')
			.format('hh:mm:ss.SSS A')
			.toString();
	}
	return moment.default(date, InputdateInCustomFormat).format(format);
};

export const dateMonthYearFormat = (date: string) => {
	//01 Jan 2020 format
	return moment.default(date).format('DD MMM YYYY');
};

//added with currency fomating for Indian language with repective currency symbol
export const currencyFormat = (number: any, currency: string) => {
	const language = navigator.language;
	const significantBits = 3;
	return new Intl.NumberFormat(language, {
		minimumFractionDigits: 0,
		maximumFractionDigits: significantBits,
		style: 'currency',
		currency: `${currency}`,
	}).format(number);
};

export const numberLanguageFormat = (value: number) => {
	const language = navigator.language;
	const significantBits = 3;

	if (value === null || value === undefined) {
		return '';
	}

	return new Intl.NumberFormat(language, {
		minimumFractionDigits: 0,
		maximumFractionDigits: significantBits,
	}).format(value as number);
};

export const validateEmail = (email: string) => {
	if (email.length > 255) {
		return false;
	}

	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

export const validateForSpecialCharacter = (password: string) => {
	const re = /[*@!#%&()^~{}]+/;
	return re.test(password);
};

export const validateForUpperCase = (password: string) => {
	const re = /[A-Z]+/;
	return re.test(password);
};

export const validateForLowerCase = (password: string) => {
	const re = /[a-z]+/;
	return re.test(password);
};

export const validateForNumber = (password: string) => {
	const re = /[0-9]+/;
	return re.test(password);
};

export const validatePassword = (password: string) => {
	if (password.length > 25) {
		return false;
	}

	const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^£?~"()[\]{}=\,\-_+\:\;\,\.\`\/\\&\*])(?=.{8,25})/;
	return re.test(password);
};
export const validatePassword12To64 = (password: string) => {
	if (password.length > 64) {
		return false;
	}

	const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^£?~"()[\]{}=\,\-_+\:\;\,\.\`\/\\&\*])(?=.{12,64})/;
	return re.test(password);
};
export const validateUrl = (url: string, numberOfCharacters: number = 255) => {
	if (url && url.length > 0) {
		if (url.length > numberOfCharacters) {
			return false;
		}

		const regex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
		return regex.test(url);
	} else {
		return true;
	}
};
export const validateURL = (
	type: string,
	url: string,
	charLimit: number = 255
) => {
	if (url && url.length > 0) {
		if (type === 'urlLength') {
			if (url.length > charLimit) {
				return false;
			} else {
				return true;
			}
		} else if (type === 'url') {
			const regex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
			return regex.test(url);
		}
	} else {
		return true;
	}
};
export const validateHttpsURL = (
	type: string,
	url: string,
	charLimit: number = 255
) => {
	if (url && url.length > 0) {
		if (type === 'urlLength') {
			if (url.length > charLimit) {
				return false;
			} else {
				return true;
			}
		} else if (type === 'url') {
			return validateHttpsRegex(url);
		}
	} else {
		return true;
	}
};
export const validateHexColor = (code: string) => {
	if (code && code.length > 0) {
		const re = /^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

		return re.test(code);
	} else {
		return true;
	}
};

export const validateSpecialChar = (value: string) => {
	if (value && value.length) {
		const regex = /[^a-zA-Z0-9\-\/\_]/;
		return regex.test(value);
	}
	return false;
};

export const pushToDataLayer = (data: any) => {
	let temp = window as any;
	if (data && data.length) {
		try {
			data.forEach((obj: any) => {
				let parsedData = JSON.parse(obj);
				temp.dataLayer.push(parsedData);
			});
		} catch (err) {
			console.log('Unable to parse the data');
			return;
		}
	}
	return temp.dataLayer;
};

export const checkPermissions = (type: string) => {
	const state: IStateType = store.getState();
	const features = state.profile.fullProfile.features;
	return includes(features, type);
};

export const redirectToDashboard = () => {
	if (
		checkPrivileges('dashboard', 'main') &&
		checkEnabledChannel(['sms', 'voice'])
	) {
		return (window.location.href = window.location.origin + '/dashboard');
	}
	if (checkNumberRole()) {
		return (window.location.href =
			window.location.origin + '/numbers/manage');
	}
	return (window.location.href = window.location.origin + '/channels');
};

export const create_UUID = () => {
	var dt = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
		/[xy]/g,
		function (c) {
			var r = (dt + Math.random() * 16) % 16 | 0;
			dt = Math.floor(dt / 16);
			return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
		}
	);
	return uuid;
};

export const numberWithCommas = (x: number | string) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const validateIpAddress = (ip: string) => {
	const regex = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
	return regex.test(ip);
};
export const validateHttpsRegex = (url: string) => {
	const regex = /[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{1,}))(?::\d{2,5})?(?:\/[^\s]*)?[?]{0,1}([^\?]+)(\?.*)?|^([Hh][Tt][Tt][Pp][Ss]?:\/\/((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:{0,1}[0-9]{0,5}))((?::\d{2,5})?(?:\/[^\s]*)?[?]{0,1}))$/g;
	return regex.test(url);
};

export const convertUnixToDate = (epoch: number, timeZone: string = '') => {
	if (timeZone && timeZone.length) {
		return moment.unix(epoch).tz(timeZone).format(`DD MMM YYYY, hh:mm:ss A`);
	}
	return moment.unix(epoch).format('DD MMM YYYY');
};

export const convertStringToArray = (str: string) => {
	let stringArr = [];
	if (str?.length) {
		stringArr = str?.split(',');
		if (stringArr?.length) {
			return stringArr;
		} else {
			return str;
		}
	} else {
		return '';
	}
};
export const dateToStringFormat = (date: Date): string => {
	// output format: 13 Jan 2021
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	];
	const formattedDate = ('0' + date.getDate()).slice(-2);
	const formattedMonth = monthNames[date.getMonth()];
	const formattedYear = date.getFullYear();
	const modifiedDate = `${formattedDate} ${formattedMonth} ${formattedYear}`;
	return modifiedDate;
};
export const convertArrayToString = (arr: any) => {
	return arr.toString();
};

export const validateOnlyNumbers = (text: string) => {
	const regex = /^\d+$/;
	return regex.test(text);
};

export const getSelectedFilterRange = (
	selectedFilter: string,
	label: number
) => {
	if (selectedFilter === '4') {
		// last three months
		const weekNumber = moment.unix(label).week();
		return `Week ${weekNumber}`;
	} else if (selectedFilter === '5') {
		// last year
		return moment.unix(label).format('MMM YY');
	} else if (selectedFilter === '3') {
		// last month
		let dateMonth = moment.unix(label).format('DD MMM');
		return dateMonth;
	} else if (selectedFilter === '2') {
		// last week
		return moment.unix(label).format('ddd');
	} else {
		// last day
		return moment.unix(label).format('HH:mm');
	}
};

export const getTooltipDateFormat = (selectedFilter: string, label: number) => {
	if (selectedFilter === '4') {
		// last three months
		let nextWeekDateUnix = moment.unix(label).add(6, 'days');
		if (nextWeekDateUnix.isAfter(moment.default(), 'day')) {
			nextWeekDateUnix = moment.default();
		}
		const nextWeekDateFormatted = nextWeekDateUnix.format('DD MMM');
		return `${moment
			.unix(label)
			.format('DD MMM')} to ${nextWeekDateFormatted}`;
	} else if (selectedFilter === '5') {
		// last year
		return moment.unix(label).format('MMM YY');
	} else if (selectedFilter === '3') {
		// last month
		let dateMonth = moment.unix(label).format('DD MMM');
		let day = moment.unix(label).format('dddd');
		const modifDate = dateMonth + ', ' + day;
		return modifDate;
	} else if (selectedFilter === '2') {
		// last week
		let dateMonth = moment.unix(label).format('DD MMM');
		let day = moment.unix(label).format('dddd');
		const modifDate = dateMonth + ', ' + day;
		return modifDate;
	} else {
		// last day
		let hour = moment.unix(label).format('HH:mm');
		let formDate = moment.unix(label).format('DD MMM');
		const modifDate = hour + ', ' + formDate;
		return modifDate;
	}
};

export const limitStringLength = (str: string, length: number) => {
	if (str.length > length + 3) {
		return str.substring(0, length) + '...';
	}
	return str;
};

export const validatePhoneNumber = (str: string) => {
	const mobileNumberRegEx = /^\d{10}$/;
	return mobileNumberRegEx.test(str);
};
export const internalUsersCheck = (emailId: string) => {
	if (!emailId) return false;
	const regex = new RegExp('@tatacommunications.+([a-zA-Z])+$');
	return regex.test(emailId);
};
export const chatbotEnabledUsers = () => {
	return ['ipsita.sinha@insightbrandcom.com'];
};

const gsm7bit =
	'|^€{}[]~\\@Δ0¡P¿p£_!1AQaq$Φ"2BRbr¥Γ#3CScsèΛ¤4DTdtéΩ%5EUeuùΠ&6FVfvìΨ\'7GWgwòΣ(8HXhxÇΘ)9IYiyLFΞ*:JZjzØESC+;KÄkäøÆ,<LÖlöCRæ-=MÑmñÅß.>NÜnüåÉ/?O§oà';
const extended = '|\\^€{}[]~';

const isValidascii = (ascii: number) => {
	return ascii === 10 || ascii === 13 || ascii === 32 || ascii === 8
		? true
		: false;
};

export const whatsappembededsignup = (current_pod: string) => {
	let regions = [];

	try {
		regions = JSON.parse(WHATSAPP_EMBEDED_SIGNUP_REGIONS)
	} catch (err) {
		//Handling Unexpected value of WHATSAPP_REGIONS_ENABLED
		regions = [];
		console.log(err);
	}

	return regions.includes(current_pod.toUpperCase());
}

export const getcharcount = (text: string) => {
	let count = 0;
	let smstype = 1;
	let charcount = 0;
	let keycount = 0;
	let message = text.split('');
	message.forEach((l) => {
		let isvalid = gsm7bit.indexOf(l);
		isvalid = isValidascii(l.charCodeAt(0)) ? 1 : isvalid;
		count = count + 1;
		if (isvalid === -1) {
			smstype = 2;
		}
	});
	// unicode return smstypw 2 and charcount
	if (smstype === 2) {
		charcount = count;
		let units = charcount > 70 ? Math.ceil(charcount / 67) : 1;
		return {
			smstype: smstype,
			count: charcount,
			keycount: count,
			units: units,
		};
	}
	smstype = 1;
	count = 0;
	keycount = 0;
	// if not an unicde check charater count
	message.forEach((l) => {
		// check if extended character present
		let isvalid = extended.indexOf(l);
		keycount++;
		if (isvalid > -1) {
			count += 2;
		} else {
			count++;
		}
	});
	charcount = count;
	let units = charcount > 160 ? Math.ceil(charcount / 153) : 1;
	return {
		smstype: smstype,
		count: charcount,
		keycount: keycount,
		units: units,
	};
};

export const validateSIPString = (str: string) => {
	const sip_pattern_exp = new RegExp(SIP_PATTERN);
	return sip_pattern_exp.test(str);
};

export const validateTitle = (
	val: string,
	maxCharLimit: number = 75,
	minCharLimit: number = 3
) => {
	if (val === undefined) return false;
	if (val.trim().length < minCharLimit || val.trim().length > maxCharLimit)
		return false;
	let regex = TITLE_VALIDATION_REGEX.test(val);
	return !regex;
};

export const checkPrivileges = (type: string, subtype:string) => {
	const state: IStateType = store.getState();
	const {
		channels = [],
		privileges,
		customer_type_id: customerTypeId
	}: any = state.profile?.fullProfile;


	if (privileges !== null && subaccountFlag === 'true') {

		const access = privileges?.[type]?.[subtype];
		
		if (subaccountCustomerTypeId.includes(customerTypeId)) {
			if (type === 'conversations') {
				return channels.includes('whatsapp') && access;
			}
			if (type === 'url_shortner') {
				return channels.includes('sms') && access;
			}
		}
		return access;
	}
	if (type === 'subaccount') {
		return false;
	}
	return true;
};

export const checkViewOnlyPrivileges = (type: string, subtype:string) => {
	const state: IStateType = store.getState();
	const {
		privileges,
		kaleyra_role,
		view_only_endpoints
	}: any = state.profile?.fullProfile;

	if (privileges !== null) {
		const access = privileges?.['view_only']?.['main'];

		if(access && viewOnlyRoleId.includes(kaleyra_role) && view_only_endpoints){
			return view_only_endpoints[type]?.includes(subtype) ? true : false
		}
	}
	return false;
};

export const checkChatbotPrivileges = () => {
	const state: IStateType = store.getState();

	if (state.profile?.fullProfile?.chatbot_product !== "1")
		return false;

	return true;
}

export const checkKaleyraExpertRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return kaleyraExpertRoles.includes(role_id);
}

export const checkSubaccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		subaccountCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkParentAccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		parentCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkResellerSubaccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		resellerSubaccountCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkEnterpriseSubaccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		enterpriseSubaccountCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkResellerAccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		resellerCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkEnterpriseAccount = () => {
	const state: IStateType = store.getState();
	const customerTypeId = state.profile?.fullProfile?.customer_type_id;

	if (
		enterpriseCustomerTypeId.includes(customerTypeId) &&
		subaccountFlag === 'true'
	)
		return true;
	return false;
};
export const checkIndianAccount = () => {
	const state: IStateType = store.getState();
	const countryId = state.profile?.fullProfile?.country_id;

	if (countryId === 277) return true;
	return false;
};

export const checkKaleyraExpertDefaultAccount = () => {
	const state: IStateType = store.getState();
	const kaleyraRole = state.profile?.fullProfile?.kaleyra_role;

	if (
		kaleyraExpertDefaultRoleId.includes(kaleyraRole)
	)
		return true ;
	return false ;
}

export const checkKaleyraExpertExtendedAccount = () => {
	const state: IStateType = store.getState();
	const kaleyraRole = state.profile?.fullProfile?.kaleyra_role;

	if (
		kaleyraExpertExtendedRoleId.includes(kaleyraRole)
	)
		 return true ;
	return false ;
}
export const checkComManagerRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	if (
		comManagerRoleId.includes(role_id)
		)
		return true ;
	return false ;
}

export const validateTxtlyUrl = (url: string) => {
	const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-z0-9]+(-{1,2}[a-z0-9]+)*\.)+[a-z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?(\?[^\s]*)?\/?$/i
	const result = url.match(regex);
	return result !== null;
};

export const getCookie = (name: string) => {
	var result = document.cookie.match(new RegExp(name + '=([^;]+)'));
	result && (result = JSON.parse(result[1]));
	return result;
};

export const checkEURegionFeatures = (route: string) => {
	if (HIDE_FEATURES && HIDE_FEATURES.split(',').includes(route)) {
		return false;
	}
	return true;
};

export const checkFailoverAccess = () => {
	const state: IStateType = store.getState();
	const company_id = state.profile?.fullProfile?.company_id;
	const email = state.profile?.fullProfile?.email;
	let emailDomain = email.split('@')[1];

	if (
		enable_failover_companies.includes(company_id) ||
		internal_domains.includes(emailDomain)
	) {
		return true;
	}
	return false;
};

export const isInternalAccount = () => {
	const state: IStateType = store.getState();
	const email = state.profile?.fullProfile?.email;
	let emailDomain = email.split('@')[1];

	if (internal_domains.includes(emailDomain)) {
		return true;
	}
	return false;
};
export const checkTextEncodingType = (text: string) => {
	var regex = /[^\u0000-\u00ff]/;
	if (!text.length) return '7Bit';
	if (text.charCodeAt(0) > 255) return 'Unicode';
	return regex.test(text) ? 'Unicode' : '7Bit';
};

// Function to replace the corresponding HTML chars with escape characters
export const SafeHtmlCleanUp = (str: string) => {
	let characters:any = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		'`': '&#x60;'
	}

	return str.replace(/[&<>"'`]/g, function(s: any) {
		return characters[s];
	});
}

export const cleanObject = (obj: Record<string, any>) => {
	for (var propName in obj) {
		if (
			obj[propName] === null ||
			obj[propName] === undefined ||
			obj[propName] === ''
		) {
			delete obj[propName];
		}
	}
	return obj;
};
export const checkSubTabsAccess = (
	subTabs: any,
	allowedchannels: string[] = ['sms', 'whatsapp', 'voice']
) => {
	const state: IStateType = store.getState();
	const {
		privileges,
		channels = [],
		customer_type_id: customerTypeId,
	}: any = state.profile?.fullProfile;

	let allowedTabs: any = [];
	let restrictedRoutes: any = [];

	for (let i = 0; i < subTabs.length; i += 1) {
		// Bypass privilege check for 'voice_sounds'
		if (subTabs[i]?.subTabKey === 'voice_sounds') {
			subTabs[i].routeAccess = true;
			allowedTabs.push(subTabs[i]);
			restrictedRoutes.push(subTabs[i]);
			continue;
		}

		if (
			privileges?.[subTabs[i]?.navBarKey]?.[subTabs[i]?.subTabKey] &&
			(subaccountCustomerTypeId.includes(customerTypeId)
				? !channels.length ||
				allowedchannels.some((e) => channels.includes(e))
				: true)
		) {
			subTabs[i].routeAccess = true;
			allowedTabs.push(subTabs[i]);
			restrictedRoutes.push(subTabs[i]);
		} else {
			subTabs[i].routeAccess = false;
			restrictedRoutes.push(subTabs[i]);
		}
	}

	return { tab: allowedTabs, routes: restrictedRoutes };
};
export const defaultRedirectTo = () => {
	if (
		checkPrivileges('dashboard', 'main') &&
		checkEnabledChannel(['sms', 'voice'])
	) {
		return '/dashboard';
	}
	if (checkNumberRole()) {
		return '/numbers/manage';
	}
	return '/channels';
};

export const checkInactivity = (timer: number) => {
	let time: any;

	const resetTimer = () => {
		clearTimeout(time);
		time = setTimeout(logout, timer);
	};

	if (!window.location.host.includes('localhost')) {
		let events = [
			'mousedown',
			'mousemove',
			'keypress',
			'scroll',
			'touchstart',
		];

		window.addEventListener('load', resetTimer, true);
		events.forEach(function (name) {
			document.addEventListener(name, resetTimer, true);
		});
	}
};

const logout = () => {
	console.log('session logged out due to inactivity.');
	redirectToLogin();
};

export const checkSupportRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return supportRoleId.includes(role_id);
};
export const checkIsNonPrimaryRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return nonPrimaryRoleId.includes(role_id);
};
export const checkNumberRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return numberRoleId.includes(role_id);
};
export const checkOperationRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return operationRoleId.includes(role_id);
};
export const kycCheck = () => {
	const state: IStateType = store.getState();
	const kyc_status = state.profile?.fullProfile?.kyc_status;
	if (kyc_status === 'APPROVED' || kyc_status === 'AUTO-APPROVED') {
		return true;
	} else return false;
};
export const checkEnabledChannel = (enabledChannel: string[]) => {
	const state: IStateType = store.getState();
	const {
		channels = [],
		customer_type_id: customerTypeId,
	}: any = state?.profile?.fullProfile;
	if (
		subaccountFlag === 'true' &&
		subaccountCustomerTypeId.includes(customerTypeId)
	)
		return enabledChannel.some((e) => channels.includes(e));
	return true;
};

export const checkWhiteListedApiKeyLimit = () =>
	Number(WHITELISTED_API_KEY_LIMIT) || 100;

export const checkIfValidIPV6 = (ip: any) => {
	// Regular expression to check if string is a IPv6 address
	const regexExp = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi;

	return regexExp.test(ip);
};
export const removeBackSlash = (ip: string) => {
	return (
		ip
			.replace(/\\/g, '')
			.replace(/\[|\]/g, '')
			.trim()
			.split('"')
			.join('') || ''
	);
};

export const isActiveWhatsappAccount = () => { 
	const state: IStateType = store.getState();
	const { wa_pricing_plan } = state.profile?.fullProfile;
	return wa_pricing_plan?.toLocaleUpperCase() === "ACTIVE";
}

export const checkForSpecificCompanyId = (session: string) => {
	// https://kaleyra.atlassian.net/browse/CNP-1846

	const state: IStateType = store.getState();
	const { company_id, parent_company_id = '' } = state.profile?.fullProfile;
	if (session === 'parent') {
		return CNP_1846_Company === company_id;
	}
	return CNP_1846_Company === parent_company_id;
};

export const isShareIpConfigWithSubaccountEnabled = () => {
	const state: IStateType = store.getState();
	const shareIpConfig = state.profile?.fullProfile?.share_ip_config;
	return shareIpConfig === '1';
};
export const checkOwnerRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;

	return ownerRoleId.includes(role_id);
};
export const checkWhatsappOnlyRole = () => {
	const state: IStateType = store.getState();
	const role_id = state.profile?.fullProfile?.kaleyra_role;
	return whatsappOnlyRoleId.includes(role_id);
};
export const isWhatsappSubaccountEnabled = () => {
	const state: IStateType = store.getState();
	const { wa_channel_for_sa } = state.profile?.fullProfile;

	return wa_channel_for_sa == "1";
};
export const isVoiceSubaccountEnabled = () => {
	const state: IStateType = store.getState();
	const { company_id } = state.profile?.fullProfile;
	const enabledCompanyId = REACT_APP_ENABLE_SUBACCOUNTS_WITH_VOICE
		? REACT_APP_ENABLE_SUBACCOUNTS_WITH_VOICE.split(',')
		: [''];

	return enabledCompanyId.includes(company_id);
};

export const checkIsConversationEnabled = () => {
	const state: IStateType = store.getState();
	const { conversation_module } = state.profile?.fullProfile;

	return conversation_module == '1';
};

export const getTime = (data: string) => {
	const date = new Date(data);
	const state: IStateType = store.getState();
	const { timezone } = state.profile?.fullProfile;
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
		hour12: false,
		timeZone: timezone?.country,
	};

	const formattedDate = date.toLocaleString('default', options);
	let datePart = '';
	let yearPart = '';
	let timePart = '';

	const parts = formattedDate.split(', ');
	if (parts.length === 3) {
		// Format: 28 Feb, 2025, 04:24:36
		[datePart, yearPart, timePart] = parts;
	} else {
		// Format: 28 Feb 2025, 04:24:36
		const [dateAndYear, time] = parts;
		const lastSpace = dateAndYear.lastIndexOf(' ');
		datePart = dateAndYear.substring(0, lastSpace);
		yearPart = dateAndYear.substring(lastSpace + 1);
		timePart = time;
	}
	

	const [day, month] = datePart.split(' ');
	const [hour, minute] = timePart.split(':');

	return `${day} ${month} ${yearPart} at ${hour}.${minute}`;
}

export const cleanSidebarArray = (arr: SidebarMenuProps) => {
	return arr.filter((item: any) => item)
		.map((item: any) => {
			Object.keys(item).forEach(key => {
				if (Array.isArray(item[key])) {
					item[key] = item[key].filter((subItem: any) => subItem);
				}
			});
			return item;
		});
}

export const isWhitelistedAccount = () => {

	const state: IStateType = store.getState();
	const { email } = state.profile?.fullProfile;

	for (const skip of whiteListedEmailKeywords) {
		if (email.toLowerCase().includes(skip.toLowerCase())) {
			// Skipping 2fa for whitelisted accounts
			return true;
		}
	}
	return false;
}

export const findLatestDeclinedDateReason = (declinedDates: any) => {
	if (!declinedDates || declinedDates.length === 0) {
		return '';
	}
	const latestDeclinedEntry = declinedDates[declinedDates.length - 1];
	const latestReason = latestDeclinedEntry.declinedReason[0].reason;
	return latestReason;
};
export const checkEUAccount =()=>{

	const state: IStateType = store.getState();
	const { user_pod } = state.profile?.fullProfile;

	return userPodEu.includes(user_pod) ;
}

export const checkUSAccount = () => {
	//As of now since there is no US pod setup yet in the Stage and PP 
	// we have to consider the Env value to disable features for US pod 
	
	// const state: IStateType = store.getState();
    // const { user_pod } = state.profile?.fullProfile;

	return REACT_APP_DISABLE_RECEIVE_MESSAGE;
    //return userPodUS.includes(user_pod.toLocaleUpperCase());
}

export const allowedChannelsForVerify = () => {
	return REACT_APP_DISABLE_VOICE_EMAIL_CHANNEL_VERIFY;
}

export const formatListWithOr = (items: Array<string>) => {
	if (items.length === 1) return items[0]; // Only one item, return as is
	if (items.length === 2) return items.join(" or "); // Two items, join with 'or'
	
	// More than two items, join with commas except the last one
	return `${items.slice(0, -1).join(", ")}, or ${items[items.length - 1]}`;
  };
